import React, { useEffect, useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { DesempenoIcon } from "../../Icons/CollaboratorsIcons";
import {
  patchProfessionalReferencesCandidate,
  getProfessionalReferencesCandidate,
} from "../../API/Candidates/References";

import ReferenceRows from "./Components/ReferenceRows/ReferenceRows";
import UploadService from "../../API/Upload/UploadService";
import Loading from "../../Components/Loading/Loading";

import "./References.sass";
import { referenceTranslate } from "../../i18n/translatedMessages";

const REGEXRule = /(documents\/candidates\/).*(.pdf)/g;

const References = () => {
  const objEmpty = {
    name: "",
    level: "",
    company: "",
    relation: "",
    phone: "",
    email: "",
    pdf: "",
    videoLink: "",
    pdfName: "",
  };

  const [references, setReferences] = useState([]);
  const [pdfFile, setPdfFile] = useState({ index: null, file: [] });
  const [loading, setLoading] = useState(false);
  const request = async () => {
    setLoading(true);
    const referenceGet = await getProfessionalReferencesCandidate(
      localStorage.getItem("candidateId")
    );
    if (
      referenceGet?.items?.professional_references &&
      referenceGet?.items?.professional_references?.length > 0
    )
      setReferences(referenceGet?.items?.professional_references);
    setLoading(false);
  };
  useEffect(() => {
    request();
  }, []);

  const handleAdd = () => {
    const auxArray = [...references];
    auxArray.push(objEmpty);
    setReferences(auxArray);
  };

  const handleChange = (index, event) => {
    const auxArray = [...references];
    auxArray[index][event.currentTarget.name] = event.currentTarget.value;
    setReferences(auxArray);
  };

  const handleDelete = async (index) => {
    const rows = [...references];

    if (index > -1) {
      rows.splice(index, 1);
      setReferences([...rows]);
      const sendAux = rows?.map((item) => {
        if (item.pdf) {
          const [pdfAux] = item?.pdf?.match(REGEXRule);
          return { ...item, pdf: pdfAux };
        }
        return { ...item };
      });
      const patchReference = await patchProfessionalReferencesCandidate(
        sendAux,
        localStorage.getItem("candidateId")
      );
    }
  };

  useEffect(() => {
    const id = localStorage.getItem("candidateId");
    if (pdfFile.index !== null) {
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        const auxArray = [...references];
        auxArray[pdfFile?.index][
          String("pdf")
        ] = `documents/candidates/${id}/references/${pdfFile.file.name}`;
        auxArray[pdfFile?.index][String("pdfName")] = `${pdfFile.file.name}`;
        setReferences(auxArray);
      };
      fileReader.readAsDataURL(pdfFile.file);
    }
  }, [pdfFile]);

  const handlePatch = async (idx) => {
    setLoading(true);
    if (Number(pdfFile.index) === Number(idx)) {
      const hash = localStorage.getItem("hash");
      const id = localStorage.getItem("candidateId");
      const fileName = pdfFile.file.name;

      const { url } = await UploadService.getAuthorizationUploadReferencesFile(fileName, hash, id);
      UploadService.UploadFile(url, pdfFile.file, "pdf");
      const sendAux = references?.map((item) => {
        if (item.pdf) {
          const [pdfAux] = item?.pdf?.match(REGEXRule);
          return { ...item, pdf: pdfAux };
        }
        return { ...item };
      });

      const patchReference = await patchProfessionalReferencesCandidate(
        sendAux,
        localStorage.getItem("candidateId")
      );

      request();
      setLoading(false);
    } else {
      const sendAux = references?.map((item) => {
        if (item.pdf) {
          const [pdfAux] = item?.pdf?.match(REGEXRule);
          return { ...item, pdf: pdfAux };
        }
        return { ...item };
      });

      const patchReference = await patchProfessionalReferencesCandidate(
        sendAux,
        localStorage.getItem("candidateId")
      );
      request();
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="row sideMenuSeparator px-2 References align-items-center">
          <div className="col-2">
            <span className="title-icon p-2 m-auto">
              <DesempenoIcon size={2} />
            </span>
          </div>
          <div className="col-10">
            <h1>{referenceTranslate.referencesTitle}</h1>
            <p className="description-section">{referenceTranslate.referencesText}</p>
          </div>
          <div className="col-12 pt-4">
            <button className="btnAddReference btn rounded-pill px-3 py-2" onClick={handleAdd}>
              <h5 className="m-0">
                {referenceTranslate.addReferenceBtn} <AiOutlinePlusCircle size={25} />
              </h5>
            </button>
          </div>
          <div className="col-12 mt-4">
            <div className="accordion" id="accordionReference">
              {references.length > 0 ? (
                references.map((refc, key) => {
                  return (
                    <ReferenceRows
                      key={key}
                      data={refc}
                      handleChange={handleChange}
                      setPdf={setPdfFile}
                      handlePatch={handlePatch}
                      index={key}
                      handleDelete={() => handleDelete(key)}
                    />
                  );
                })
              ) : (
                <div className="text-center greyBox py-5">
                  <h5 className="m-0">{referenceTranslate.emptyReference}</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default References;
